<template lang="pug">
  .b2b-table-cierrescontables
    b2b-filters-cierres-contables(
      @filters-changed='filtersHaveChanged',
      ref='filtersCierresContables')
    ods-table(
      ref='tablaCierresContables',
      :data='cierresContables.content',
      :start-sort='tableSort',
      style='width: 100%',
      @sort-change='sortHasChanged',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row,
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='projectName',
        :label='$t("accounting_closes.entity_table.project")',
        :show-overflow-tooltip='true',
        v-if='isAccountingCloseTableProjectNameShown',
        sortable='')
      ods-table-column(
        prop='buyerName',
        :label='$t("accounting_closes.entity_table.buyer")',
        :show-overflow-tooltip='true',
        v-if='isAccountingCloseTableBuyerNameShown')
      ods-table-column(
        prop='name',
        :label='$t("accounting_closes.entity_table.name")',
        :show-overflow-tooltip='true',
        v-if='isAccountingCloseTableNameShown',
        sortable='')
      ods-table-column(
        prop='closeDateTime',
        :label='$t("accounting_closes.entity_table.close_date_time")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isAccountingCloseTableCloseDateTimeShown',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='status',
        :label='$t("accounting_closes.entity_table.status")',
        :show-overflow-tooltip='true',
        v-if='isAccountingCloseTableStatusShown',
        :formatter='formatterStatus')
      ods-table-column(
        prop='startDate',
        :label='$t("accounting_closes.entity_table.start_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isAccountingCloseTableStartDateShown',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='endDate',
        :label='$t("accounting_closes.entity_table.end_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isAccountingCloseTableEndDateShown',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='childAccountingCloseName',
        :label='$t("accounting_closes.entity_table.child_accounting_close_name")',
        :show-overflow-tooltip='true',
        v-if='isAccountingCloseTableChildAccountingCloseNameShown')
        template(slot-scope='scope')
          span.blue-text(style='cursor: pointer;',v-if='scope.row.childAccountingCloseName')
            a(
              @click='goToDetail(scope.row.childAccountingCloseId)'
            )
              | {{ scope.row.childAccountingCloseName }}
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='80')
        template(slot-scope='scope')
          ods-tooltip(:content='$t("invoices.tooltip.detail")', placement='bottom')
            ods-button.first-button(
              v-if='!draftId',
              type='neutral',
              icon-position='left'
              @click='goToDetail(scope.row.id)')
              ods-icon(name='search', size='16')
          ods-tooltip(:content='$t("accounting_closes.validate_signature")', placement='bottom')
            ods-button(
              v-if='!draftId',
              type='neutral',
              @click='validateSigned(scope.row.id)')
              ods-icon(name='tick', size='16')
          ods-tooltip(:content='$t("accounting_closes.entity_table.add")', placement='bottom')
            ods-button(
              v-if='draftId',
              type='neutral',
              align='center',
              icon-position='right'
              style=' padding-left: 0px; padding-right: 0px; color: #2E6C99;'
              @click='addAccountingClose(scope.row)')
              ods-icon(name='plus', size='16')
    //- Paginación Tabla
    ods-row.b2b-table-cierrescontables__pagination()
      ods-col.b2b-table-cierrescontables__pagination--right(:span='24')
        ods-pagination(
          ref='pagination',
          popper-class='b2b-pagination__dropdown',
          @size-change='pageSizeChanged',
          @current-change='currentPageChanged',
          :current-page.sync='pagination.currentPage',
          :page-sizes='[20, 50, 100]',
          :page-size='pagination.pageSize',
          layout='total, sizes, prev, pager, next, slot',
          :total='pagination.totalElements')

    //- Cierres Contables Seleccionados
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersCierresContables from './B2bFiltersCierresContables'
import B2bTableMenuCierresContables from './B2bTableMenuCierresContables'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-cierrescontables',
  mixins: [Utils],
  data () {
    return {
      draftId: null,
      cierresContables: {
        content: [],
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        size: 0,
        sort: {
          direction: 'DESC',
          field: 'closeDateTime'
        },
        totalElements: 0,
        totalPages: 0
      },
      loading: false,
      tableSort: {
        prop: 'closeDateTime',
        order: 'descending'
      },
      pagination: {
        currentPage: 0,
        totalElements: 0,
        pageSize: 20
      },
      queryParams: {},
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: []
    }
  },

  computed: {
    ...mapGetters([
      'isAccountingCloseTableProjectNameShown',
      'isAccountingCloseTableBuyerNameShown',
      'isAccountingCloseTableNameShown',
      'isAccountingCloseTableCloseDateTimeShown',
      'isAccountingCloseTableStatusShown',
      'isAccountingCloseTableStartDateShown',
      'isAccountingCloseTableEndDateShown',
      'isAccountingCloseTableChildAccountingCloseNameShown'
    ])
  },

  components: {
    B2bFiltersCierresContables,
    B2bTableMenuCierresContables,
    B2bTableSelectRows
  },

  watch: {
    $route (to) {
      // this.cierresContables = this.cierresContables
    }
  },

  methods: {
    ...mapActions([
      'getAccountingCloses',
      'addChildAccounting',
      'verifyAccountinClose',
      'getOptionsService',
      'resetSession',
      'optionsServicesEnabledState'
    ]),

    async doSearch (loadingText) {
      if (this.loading) {
        return false
      }
      this.loading = true
      const load = this.$loading({
        lock: true,
        text: loadingText
      })
      this.cleanResults()
      try {
        if (this.queryParams === null || this.queryParams === undefined) {
          this.queryParams = {}
        }
        if (!this.queryParams.statusId) {
          this.queryParams.statusId = 2
        }
        this.queryParams.size = this.pagination.pageSize
        this.queryParams.page =
          this.pagination.currentPage > 0
            ? this.pagination.currentPage - 1
            : undefined
        this.queryParams.sort =
          this.tableSort.prop != null
            ? this.tableSort.prop +
              ',' +
              (this.tableSort.order === 'ascending' ? 'ASC' : 'DESC')
            : undefined
        this.cierresContables = await this.getAccountingCloses(
          this.queryParams
        )
        this.checkTableSort(this.cierresContables.sort)
        this.checkTablePagination(
          this.cierresContables.size,
          this.cierresContables.number,
          this.cierresContables.totalElements
        )
        console.log('doSearch RESULT: ', this.cierresContables)
      } catch (error) {
        console.error('doSearch CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
        this.loading = false
      }
    },

    cleanResults () {
      this.cierresContables = {
        content: [],
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        size: 0,
        sort: {
          direction: 'DESC',
          field: 'closeDateTime'
        },
        totalElements: 0,
        totalPages: 0
      }
    },

    checkTableSort (sort) {
      if (
        sort === null ||
        sort === undefined ||
        sort.field === null ||
        sort.field === undefined
      ) {
        this.tableSort = {
          prop: null,
          order: null
        }
        this.$refs.tablaCierresContables.clearSort()
      } else {
        const sortAux = {
          prop: sort.field,
          order: sort.direction === 'ASC' ? 'ascending' : 'descending'
        }
        if (
          sortAux.prop !== this.tableSort.prop ||
          sortAux.order !== this.tableSort.order
        ) {
          this.tableSort = sortAux
          this.$refs.tablaCierresContables.clearSort()
          this.$refs.tablaCierresContables.sort(
            this.tableSort.prop,
            this.tableSort.order
          )
        }
      }
    },

    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    /** Guarda los cambios del cierre */
    async addAccountingClose () {
      console.log('saveAccountingData: ', this.draftDetailForm)
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.save_changes')
      })
      try {
        const request = {
          childAccountingCloseId: (this.currentRow && this.currentRow.id ? '' + this.currentRow.id : ''),
          id: (this.draftId ? this.draftId : null)
        }
        const response = await this.addChildAccounting(request)
        this.draftDetailForm = response
        this.$notify({
          title: this.$t('accounting_closes.notify.update_changes'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        sessionStorage.setItem('draftId', this.draftId)
        router.push({
          name: 'borradorcierre-detail',
          params: {
            draftId: this.draftId
          }
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    checkTablePagination (size, page, totalElements) {
      this.pagination = {
        currentPage: totalElements > 0 ? page + 1 : 0,
        totalElements: totalElements,
        pageSize: size
      }
    },

    async doFirstSearch () {
      this.draftId = (this.$route.params && this.$route.params.draftId ? this.$route.params.draftId : null)

      this.queryParams = this.$refs.filtersCierresContables.getQueryParams()
      this.pagination.currentPage = this.queryParams.page ? this.queryParams.page : this.pagination.currentPage
      this.pagination.pageSize = this.queryParams.size ? this.queryParams.size : this.pagination.pageSize
      await this.doSearch(this.$t('msg_generics.load_init'))
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$i18n.messages.es.error.e500
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      let errorArgList = []
      errorArgList = error.data.errorArgList
      if (errorArgList != null && errorArgList && errorArgList[0] && errorArgList[0].codesList != null) {
        for (let i = 0; i < errorArgList.length; i++) {
          let fullMessage = ''
          for (let j = 0; j < errorArgList[i].codesList.length; j++) {
            if (errorArgList[i].codesList != null) {
              fullMessage = fullMessage + errorArgList[i].codesList[j] + '. '
            }
          } if (errorArgList[i].arguments === 'Ok.') {
            await this.$notify({
              title: errorArgList[i].arguments + fullMessage,
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000

            })
          } else {
            await this.$notify({
              title: errorArgList[i].arguments + fullMessage,
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: 10000
            })
          }
        }
      } else {
        this.showNotificationError(error)
      }
    },

    async sortHasChanged (sort) {
      if (this.loading) {
        return
      }
      if (
        this.tableSort.prop !== sort.prop ||
        this.tableSort.order !== sort.order
      ) {
        this.tableSort = {
          prop: sort.prop,
          order: sort.order
        }
        await this.doSearch(this.$t('msg_generics.order_table'))
      }
    },

    async pageSizeChanged (size) {
      if (this.loading) {
        return
      }
      this.pagination.pageSize = size
      await this.doSearch(this.$t('msg_generics.size_table'))
    },

    async currentPageChanged (page) {
      if (this.loading) {
        return
      }
      this.pagination.currentPage = page
      await this.doSearch(this.$t('msg_generics.pagination_table'))
    },

    async filtersHaveChanged (queryParams) {
      this.queryParams = queryParams
      if (this.loading) {
        return
      }
      await this.doSearch(this.$t('msg_generics.load_init'))
    },

    formatterStatus (row, column) {
      return this.$t('status_accounting_close.' + row[column.property])
    },

    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },

    async goToDetail (accountingCloseId) {
      console.log('Go to detail: ', accountingCloseId)
      sessionStorage.setItem('accountingName', this.currentRow.name)

      router.push({
        name: 'cierre-detail',
        params: {
          draftId: accountingCloseId,
          accountingName: this.currentRow.name
        }
      })
    },
    async validateSigned (accountingCloseId) {
      if (this.loading) {
        return false
      }
      this.loading = true
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })

      if (this.queryParams === null || this.queryParams === undefined) {
        this.queryParams = {}
      }
      this.queryParams.id = accountingCloseId
      try {
        const response = await this.verifyAccountinClose(this.queryParams)
        if (response.statusCode === 'verification.ok') {
          this.$notify({
            title: this.$t('accounting_closes.notify.verification_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } else {
          this.$notify({
            title: this.$t('accounting_closes.notify.verification_ko'),
            type: 'error',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }
      } catch (error) {
        console.error('doSearch CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
        this.loading = false
      }
    },

    renderHeaderActions: h => {
      return <B2bTableMenuCierresContables />
    }
  },

  async created () {
    let sortStrings = []
    try {
      const dataQueryProj = { page: 0, size: 1000, sort: 'name,ASC' }
      const optionsFilterService = await this.getOptionsService(dataQueryProj)
      await this.optionsServicesEnabledState(optionsFilterService)

      if (optionsFilterService.length === 1) {
        this.queryParams.projectId = optionsFilterService[0].id
      }

      sortStrings = this.queryParams.sort
        ? this.queryParams.sort.split(',')
        : []
      this.tableSort = {
        prop: sortStrings.size() > 0 ? sortStrings[0] : 'closeDateTime',
        order:
          sortStrings.size() > 1
            ? sortStrings[1] === 'ASC' ? 'ascending' : 'descending'
            : 'descending'
      }
    } catch (exception) {
      this.tableSort = {
        prop: 'closeDateTime',
        order: 'descending'
      }
    }
    this.pagination = {
      currentPage: this.queryParams.page ? this.queryParams.page + 1 : 0,
      totalElements: 0,
      pageSize: this.queryParams.size ? this.queryParams.size : 20
    }
    delete this.queryParams.sort
    delete this.queryParams.page
    delete this.queryParams.size
  },

  async mounted () {
    await this.doFirstSearch()
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-cierrescontables {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    span.blue-text {
      color: var(--color-bg-interactive);
    }
    ::v-deep &__row {
      .cell {
        padding: rem(0)!important;
        .text-overflow-tooltip {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .ods-button.is-round {
          padding: rem(0)!important;
        }
        .ods-button + .ods-button {
          margin-left: 0px !important;
        }
      }
      .ods-button {
        padding: rem(0);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
        display: contents;
      }
      .first-button {
        padding: rem(0);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }
  ::v-deep .ods-button.is-round {
      padding: rem(0)!important;
    }
    ::v-deep .ods-button + .ods-button {
      margin-left: rem(1)!important;
    }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}
</style>
